import { PlanPeriods } from '@/config';
import { Plan } from '@/api/amlbotAPI';

export const INDIVIDUAL_PRO_PLUS_PLAN_VALUE = '100,000+';

export const INDIVIDUAL_PRO_PLUS_PLAN: Plan = {
  id: 'individual-pro-plus',
  name: '100,000+ credits',
  addition: 'b2b',
  sku: 'individual-pro-plus',
  options: [
    'plan_opt_advantages_08',
    'plan_opt_advantages_09',
    'plan_opt_advantages_10',
    'plan_opt_advantages_11',
    'plan_opt_advantages_12',
    'plan_opt_advantages_13',
    'plan_opt_advantages_14',
    'plan_opt_advantages_15',
  ],
  description: 'Individual Pro+ plan',
  periodicity: PlanPeriods.UNLIMITED,
  support_only: 'false',
  options_data: '',
  isAdvert: false,
  price: '',
  old_price: '',
  value: INDIVIDUAL_PRO_PLUS_PLAN_VALUE,
  description_translated: '',
  per_check_str: '0',
};
